import React from 'react'
import Drawer from "react-drag-drawer";
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi';
import { BsArrowLeftCircle } from 'react-icons/bs';
import LogoPng from '../../assets/images/new/logo.webp'

const QuestionsModal = (props) => {
  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
  }

  return (
    <Drawer
      dontApplyListeners={true}
      allowClose={false}
      open={props.isOpened}
      onRequestClose={props.close}
      direction="left"
      containerElementClass="h-override"
      modalElementClass="h-override fixed top-0 left-0 z-10"
    >
      <div
        className='w-screen max-w-lg h-override bg-modal flex flex-col justify-start items-start px-4 text-lg overflow-y-auto'
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16,
          overflowY: "auto"
        }}
      >
        <div className='w-full flex flex-row justify-between items-center'>
          <div
            className='flex flex-row justify-start items-center cursor-pointer'
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={() => {
              playSong(songsName.TAP)

              props.backToDrawerMenu()
            }}
          >
            <BsArrowLeftCircle className="w-8 h-8 text-pallet-1" />
          </div>

          <img src={LogoPng} className='h-8 mx-auto' alt='Logo' />

          <button
            type="button"
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={closeHandler}
            className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
          >
            <FiX className="w-8 h-8 text-pallet-1" />
          </button>
        </div>

        <h2 className='text-pallet-1 font-bold text-xl text-center mx-auto my-8'>Dúvida</h2>

        <div className='text-lg'>
          <h3 className='font-semibold'>1. Como posso ler os contos?</h3>
          <p>Para ler os livros você precisa entrar com uma empresa parceira da Máquina de Contos da qual seja cliente ou fazer uma assinatura. Deste modo, você receberá um novo conto todo os meses para acrescentar à sua biblioteca. Além disso, você recebe uma biblioteca de contos de presente no primeiro acesso.</p>
          <br />

          <h3 className='font-semibold'>2. Para que público os contos são indicados?</h3>
          <p>Os títulos da Máquina de Contos são adequados para o público adulto</p>
          <br />

          <h3 className='font-semibold'>3. Quantos títulos eu recebo por mês?</h3>
          <p>A Máquina de Contos entrega sempre um novo volume a cada mês, que pode conter um único conto ou um conjunto de contos de mesma autoria.</p>
          <br />

          <h3 className='font-semibold'>4. Posso escolher meus contos?</h3>
          <p>Um dos objetivos da Máquina de Contos é apresentar diferentes autores contemporâneos, para que nossos leitores não apenas reencontrem aqueles que já admiram, mas que descubram novas escritas. Para isso, nossa curadoria seleciona cuidadosamente os contos que serão entregues e que farão parte da sua biblioteca. Queremos que os leitores tenham acesso não apenas ao que já conhecem e apreciam, mas também ao novo, para que conheçam e façam sua avaliação. Convidamos você a apreciar as escolhas da nossa curadoria. Seu novo autor preferido pode estar a um clique de distância!</p>
          <br />

          <h3 className='font-semibold'>5. Quando chegam os contos novos?</h3>
          <p>Os novos contos chegam sempre no dia 1º de cada mês.</p>
          <br />

          <h3 className='font-semibold'>6. Preciso fazer download dos meus livros?</h3>
          <p>Seus contos podem ser lidos online e offline. Mas para acessá-los sem estar conectado à Internet você precisa fazer o download no aplicativo. Além disso, ao fazer o download, você guarda seus livros para sempre, mesmo que deixe de ser assinante ou cliente de uma empresa parceira.</p>
          <br />

          <h3 className='font-semibold'>7. Por que não consigo ler meus livros?</h3>
          <p>Se você não estiver conectado à Internet, não conseguirá ler os livros a não ser que tenha feito download no app anteriormente. Aproveite para baixá-los quando estiver conectado ao wi-fi e assim poder acessá-los em qualquer lugar, mesmo sem conexão.</p>
          <br />

          <h3 className='font-semibold'>8. Por quanto tempo os contos ficam disponíveis para serem baixados? </h3>
          <p>Os novos títulos ficam disponíveis para serem lidos online e baixados por 2 anos desde a data de entrega. Faça o download neste período para guardar seus contos para sempre. Lembre-se, os livros são seus! Os livros da biblioteca que você recebe de presente ao se juntar à Máquina de Contos podem ficar disponíveis por menos tempo. A data limite para o download de cada livro é informada junto às capas.</p>
          <br />

          <h3 className='font-semibold'>9. Por que não estou recebendo contos novos?</h3>
          <p>Se você parou de receber novos volumes, significa que sua assinatura foi cancelada ou está expirada, ou que você deixou de ter acesso por meio da empresa parceira a qual estava vinculado, seja porque não é mais cliente ou porque alterou seu plano. Nem todos os planos oferecidos pela empresa parceira podem dar direito aos contos da Máquina de Contos.</p>
          <br />

          <h3 className='font-semibold'>10. Quanto custa assinar a Máquina de Contos?</h3>
          <p>A assinatura custa R$19,90 por mês. </p>
          <br />

          <h3 className='font-semibold'>11. Por quanto tempo é válida a assinatura?</h3>
          <p>Sua assinatura se renova mensalmente até o momento que você decida suspendê-la ou cancelá-la.</p>
          <br />

          <h3 className='font-semibold'>12. Como posso cancelar uma assinatura?</h3>
          <p>Você pode cancelar sua assinatura a qualquer momento. Vá até sua loja de aplicativos, na seção de gerenciamento de assinaturas, para fazer o cancelamento se assim desejar.</p>
          <br />

          <h3 className='font-semibold'>13. Se eu cancelar a assinatura perco minha biblioteca?</h3>
          <p>Não! Você é dono dos livros da sua biblioteca, mesmo os que você recebeu de presente quando se juntou à Máquina de Contos. Se você cancelar sua assinatura, não receberá mais novos contos, mas os livros da sua biblioteca permanecerão com você. Lembre-se de fazer o download de todos os seus livros para guardá-los para sempre.</p>
          <br />

          <h3 className='font-semibold'>14. Como ter acesso com uma empresa parceira?</h3>
          <p>Clique em Entrar, e então escolha a opção Empresa Parceira. Localize a empresa da qual você é cliente e digite as credenciais de acesso informadas pela empresa. Se você não tiver ou não lembrar destas credenciais, procure a empresa.</p>
          <br />

          <h3 className='font-semibold'>15. Sou cliente de uma empresa parceira da Máquina de Contos, mas não consigo entrar. Por que?</h3>
          <p>São as empresas parceiras que definem quais de seus clientes têm acesso à Máquina de Contos. Algumas vezes, o acesso está limitado a determinado tipo de plano ou produto contratado. Se você é cliente, recomendamos que você entre em contato com a empresa para saber se você está contemplado.</p>
          <br />

          <h3 className='font-semibold'>16. Se eu deixar de ser cliente da empresa parceira perco minha biblioteca?</h3>
          <p>Não! Você é dono dos livros da sua biblioteca, mesmo os que você recebeu de presente quando se juntou à Máquina de Contos. Se você deixou de ser cliente da empresa ou mudou seu plano para outro que não inclui a Máquina de Contos, não receberá mais novos livros, mas os contos da sua biblioteca permanecerão com você. Lembre-se de fazer o download de todos os seus livros para guardá-los para sempre.</p>
          <br />

          <h3 className='font-semibold'>17. Não sei informar os dados de acesso da empresa parceira. Onde posso obtê-los?</h3>
          <p>Cada empresa parceira utiliza dados de acesso diferentes, que podem ser número de telefone, e-mail, CPF, número de cliente, código e outros. Ao solicitar acesso à Máquina de Contos com uma empresa parceira, você será informado sobre quais dados são utilizados por esta empresa como credencial de acesso. Se você não tiver estas credenciais, solicite à empresa. </p>
          <br />

          <h3 className='font-semibold'>18. Se eu desinstalar o aplicativo perco minha biblioteca?</h3>
          <p>Se você desinstalar a Máquina de Contos vamos entender que você não tem mais interesse na sua biblioteca e quer usar o espaço de armazenamento de seu dispositivo de outra forma. Assim, vamos eliminar os livros da sua biblioteca. Se mudar de ideia e quiser instalar novamente o app, você poderá baixar novamente os livros, desde que o período de disponibilidade para download não tenha expirado.</p>
          <br />

          <h3 className='font-semibold'>19. Posso compartilhar os livros da minha biblioteca?</h3>
          <p>Queremos que você compartilhe impressões e experiências, não livros. As obras estão protegidas pelas leis de direitos autorais, por isso não é permitido compartilhá-las. Se você gostou do livro, valorize os autores respeitando seus direitos e protegendo a obra.</p>
          <br />

          <h3 className='font-semibold'>20. Minha dúvida não está aqui, como posso resolver meu problema?</h3>
          <p>Entre em contato conosco, vamos ter enorme satisfação em esclarecer suas dúvidas, receber suas críticas ou elogios. Utilize a seção Fale conosco no menu principal ou escreva para contato@maquinadecontos.com.br</p>
          <br />

          <h3 className='font-semibold'>21. Como posso falar com a Máquina de Contos?</h3>
          <p>Utilize a seção Fale conosco, no menu principal, ou escreva para <a className='text-pallet-9 underline' href='mailto:contato@maquinadecontos.com.br'>contato@maquinadecontos.com.br</a>. A gente promete que vai responder bem rápido!</p>
          <br />
        </div>
      </div>
    </Drawer>
  )
}

export default QuestionsModal